module.exports = __webpack_public_path__ + "img/farmOS-logo.f5fe8be2.png";